export { default } from './SpriteAnimate';



// WEBPACK FOOTER //
// ./src/client/js/view/components/SpriteAnimate/index.js